import {
  getPhoneNumber,
  getPrimaryLocation,
} from '@provider-directory/models/provider.model';
import type {
  ProviderLocationResource,
  ProviderResource,
} from '@provider-directory/types/providers.contracts';
import type { AssociationPhoneSelection } from '@provider-directory/types/runtime-config.contracts';
import { getLocationPhone } from './location';

/**
 * Selects the best available phone number by the following hierarchy:
 * selected location phone number > primary location phone number > association phone number
 */
export const getAvailablePhoneNumber = (
  selectedLocation: ProviderLocationResource | null,
  provider: ProviderResource | null,
  selection?: AssociationPhoneSelection,
): string => {
  if (selectedLocation) {
    const locationPhone = getLocationPhone(selectedLocation);
    if (locationPhone) return locationPhone;
  }

  return (provider && getPhoneNumber(provider, selection)) || '';
};

/**
 * Same hierarchy as getAvailablePhoneNumber, but for contexts (e.g. decision
 * tree error modals) that only have a provider, not a specific selected
 * location — always resolves against the provider's primary location.
 */
export const getProviderPrimaryPhoneNumber = (
  provider: ProviderResource | null | undefined,
  selection?: AssociationPhoneSelection,
): string | undefined => {
  if (!provider) {
    return undefined;
  }

  return getAvailablePhoneNumber(
    getPrimaryLocation(provider.locations) ?? null,
    provider,
    selection,
  );
};
